export default {
  areas: {
    hero: {
      eyebrow: 'Područje djelovanja',
      title: 'Sigurnosne kamere i alarmi na cijelom području Rhein-Main',
      subtitle: 'Od Frankfurta preko Offenbacha, Hanaua i Darmstadta do Groß-Geraua: SSG Signaltechnik planira, ugrađuje i održava videonadzor i alarmne sustave za privatne i poslovne korisnike – osobno i na licu mjesta.',
      ctaPrimary: 'Zatražite besplatno prvo savjetovanje',
      ctaSecondary: 'Otkrijte videonadzor',
    },
    breadcrumbHome: 'Početna',
    breadcrumbCurrent: 'Područje djelovanja',
    intro: {
      eyebrow: 'Gdje smo aktivni za vas',
      title: 'Kratke udaljenosti u cijeloj regiji',
      p1: 'Naš stručni obrt za sigurnosnu tehniku sjedište ima u Hainburgu – i odatle se brzo kreće cijelim područjem Rhein-Main. Sigurnosna kamera, videonadzor ili alarm: dolazimo k vama, analiziramo objekt i sve montiramo uredno i stručno.',
      p2: 'Privatna kuća, višestambena zgrada, trgovina, ured, skladište ili radionica – vodimo projekte svih veličina u Frankfurtu, Offenbachu, Hanauu, Darmstadtu, Groß-Gerauu i okolnim gradovima.',
    },
    city: 'Grad',
    district: 'Okrug',
    coverage: {
      eyebrow: 'Lokalno ukorijenjeni',
      title: 'Vaš stručni obrt iz regije – za regiju',
      p1: 'Kao lokalni stručni obrt za sigurnosnu tehniku na području Rhein-Main poznajemo zahtjeve i uvjete na terenu. Za vašu kameru ili alarm to znači: kratki putovi, osobni kontakti i brzi termini.',
      p2: 'Krećemo se i izvan područja Rhein-Main po dogovoru. Javite nam se – rado provjeravamo što je moguće za vaš projekt.',
      ctaPrimary: 'Zatražite sada',
      ctaSecondary: 'Otkrijte alarmne sustave',
      caption: 'Osobna montaža i postavljanje na licu mjesta – iz Hainburga cijelim područjem Rhein-Main.',
    },
    cta: {
      title: 'Sigurnosna kamera ili alarm za vaš objekt?',
      lead: 'Savjetujemo vas bez obveze i pokazujemo koje rješenje odgovara vašem objektu i budžetu – na cijelom području Rhein-Main i okolici.',
      primary: 'Zatražite besplatno prvo savjetovanje',
      secondary: 'Pokrenite planer kamera',
    },
  },
};